import request from "superagent";

import { getTabToken } from "common/MetaActions";
import config from "config/config";
import { Banner } from "models/dashboard/dashboard";

export class BannersAPI {
  static async getBannersList(): Promise<Banner[]> {
    const response = await request
      .get(config.api.banners.getAll())
      .set("Authorization", "Bearer " + getTabToken())
      .send();
    return response.body;
  }
}
